<script lang="ts">
      import Image from '$lib/components/gallery/Image.svelte'
      import ImageElement from '$lib/components/gallery/ImageElement.svelte'
      import LexicalBlock from '$lib/components/lexical/LexicalBlock.svelte'
      import LexicalRender from '$lib/components/lexical/LexicalRender.svelte'
      import Button from '$lib/components/ui/Button.svelte'
      import Full from './Full.svelte'
      import Placeholder from './Placeholder.svelte'
      import Split from './Split.svelte'

      let { content = undefined } = $props()
</script>

<!--{#if type == "split"}
{:else if type == "full"}
<Full></Full>
{:else}
<Placeholder></Placeholder>
{/if}-->

{#if content }
<!--<Split></Split>
{/if}
{#if content == false}-->
      <div class="hero grid grid-rows-[auto] lg:grid-rows-1 grid-cols-1 { content.length == 1 ? "" : "lg:grid-cols-2" } items-center gap-4 bg-[#f2F2F2]">
            {#each content as block, i (i)}
                  {#if block.blockType == 'imageBlock'}
                        <div class="w-full h-full flex">
                              <ImageElement image={block.image}></ImageElement>
                        </div>
                  {/if}
                  {#if block.blockType == 'lexicalBlock'}
                        <div class="w-full h-full p-8 flex items-center">
                              <LexicalRender root={block.lexical.root}></LexicalRender>
                        </div>
                  {/if}
            {/each}
      </div>
{/if}

<style lang="postcss">
      .hero :global(.lexical-output) :global(.lexical-heading) {
            @apply font-normal text-4xl;
      }

      .hero :global(.lexical-output) :global(.lexical-heading.lexical-h1) {
            @apply font-normal text-4xl;
      }

      .hero :global(.lexical-output) :global(p) {
            @apply font-['nunito-sans'] text-xl font-normal;
      }
</style>
